import React, { PureComponent } from 'react'
import { Button, Form, Message, Modal, Icon } from 'semantic-ui-react'
import { Redirect } from 'react-router-dom'
import { login } from '../../services/self'
import { confirmMarketplaceSubscription } from '../../services/api-catalog'
import logo from '../../logo.png'

 export default class SignIn extends PureComponent {
   state = {
     isSubmitting: false,
     signedIn: false,
     errorMessage: '',
     isOpen: false
   }
   open = () => this.setState({ isSubmitting: false, errorMessage: '', isOpen: true })
   close = () => this.setState({ isOpen: false })
   handleLogin = (event, serializedForm) => this._handleLogin(event, serializedForm)

  _handleLogin(event, serializedForm) {
    event.preventDefault()
    this.setState({isSubmitting: true})

    login(serializedForm.email, serializedForm.password)
    .then(() => {
        this.setState({signedIn: true, isSubmitting: false, errorMessage: ''})

        const { usagePlanId, token } = this.props

        if (usagePlanId && token) {
   	       return confirmMarketplaceSubscription(usagePlanId, token)
        }
    })
    .catch((e) => this.setState({errorMessage: e.message, isSubmitting: false}))
  }

  render() {
    const { isOpen } = this.state

    return this.state.signedIn ? <Redirect to='/apis' /> : (
      <Modal size='small' className="modalSignIn" open={isOpen} onOpen={this.open} onClose={this.close} trigger={<Button className="signInBtn">SIGN IN</Button>}>
      <div className="centerHeader">
        <br/>
        <span style={{fontSize: '25px'}}>Hello, welcome back.</span>
        <br/>
      </div>
        <Modal.Content>
        <Icon name="close" size="big" style={{position:"absolute", top:"15px", right:"10px", color: "#C0C0C0"}} onClick={this.close}/>
        <div className="wrapper">
          <Form onSubmit={this.handleLogin} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
            <Message error content={this.state.errorMessage} />
            <div className="form-group">
              <input name='email' className="form-control formText inputPadding" placeholder="Email"/>
            </div>
            <div className="form-group">
              <input type='password' name='password' placeholder="Password" autoComplete='false' className="form-control formText inputPadding"/>
            </div>
            <Modal.Actions style={{textAlign: 'right', paddingTop: '10px'}}>
              <Button type='submit' color='green' size='big'><span className="modalBtn">SIGN IN</span></Button>
            </Modal.Actions>
          </Form>
        </div>
        </Modal.Content>
      </Modal>)
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SignIn/index.js
 **/